import { createContext } from 'react';
import type { MessageGenSession, MessageGenState, CreateMessageGenSessionRequest, MessageGenPageContext, MarketingMessage, MessageGenPhase } from '@trinity/chat';
import type { GridRowSelectionModel } from '@mui/x-data-grid';

export type MessageGenerationDispatch = (state: MessageGenState) => void;
export type MessageGenerationCreateSession = (data: {
  sessionId?: string;
  brandIdentifier: string;
  initialState?: CreateMessageGenSessionRequest['initialState'];
  pageContext?: MessageGenPageContext;
}) => void;
export type MessageGenerationLoadSession = (messageGenSessionId: number) => void;
export type MessageGenerationResetSession = () => Promise<void>;

export interface MessageGenerationTableActions {
  messages: MarketingMessage[];
  selectionModel: GridRowSelectionModel;
  sessionId?: number;
  phase?: MessageGenPhase;
  isSaving: boolean;
  onSaveSelected: (messageIdentifiers: string[]) => void;
  onResetSession: () => Promise<void>;
}

export type SetMessageGenerationTableActions = (actions: MessageGenerationTableActions | null) => void;

export const MessageGenerationStateContext = createContext<MessageGenSession | null>(null);
MessageGenerationStateContext.displayName = 'MessageGenerationStateContext';

export const MessageGenerationDispatchContext = createContext<MessageGenerationDispatch | null>(null);
MessageGenerationDispatchContext.displayName = 'MessageGenerationDispatchContext';

export const MessageGenerationCreateSessionContext = createContext<MessageGenerationCreateSession | null>(
  null
);
MessageGenerationCreateSessionContext.displayName = 'MessageGenerationCreateSessionContext';

export const MessageGenerationLoadSessionContext = createContext<MessageGenerationLoadSession | null>(null);
MessageGenerationLoadSessionContext.displayName = 'MessageGenerationLoadSessionContext';

export const MessageGenerationResetSessionContext = createContext<MessageGenerationResetSession | null>(null);
MessageGenerationResetSessionContext.displayName = 'MessageGenerationResetSessionContext';

export const MessageGenerationTableActionsContext = createContext<SetMessageGenerationTableActions | null>(null);
MessageGenerationTableActionsContext.displayName = 'MessageGenerationTableActionsContext';

export const MessageGenerationTableActionsValueContext = createContext<MessageGenerationTableActions | null>(null);
MessageGenerationTableActionsValueContext.displayName = 'MessageGenerationTableActionsValueContext';
